export const categories = ['all', 'in-beta', 'in-development', 'live', 'scheduled-for-release', 'sunset', 'recommended', 'new-to-you', 'your-betas'];